import { Pencil, Trash2 } from "lucide-react";
import { Button } from "../ui/button";
import { KondisiBadge } from "../KondisiBadge";

const first = (v) => String(v || "").split("\n")[0];

export const ItemCards = ({ cat, rows, start, showPolda, onEdit, onDelete }) => {
  const fields = cat.list.map((k) => cat.fields.find((f) => f.key === k));
  const [titleF, ...rest] = fields.filter((f) => f.key !== "kondisi");
  const hasK = fields.some((f) => f.key === "kondisi");
  return (
    <ul className="divide-y" data-testid="items-cards">
      {rows.map((it, i) => (
        <li key={it.item_id} className="p-4 active:bg-muted/50 transition-colors" data-testid={`item-card-${it.item_id}`}>
          <div className="flex items-start gap-3">
            <span className="font-mono text-xs text-muted-foreground pt-0.5 w-6 shrink-0">{start + i + 1}</span>
            <button type="button" className="flex-1 min-w-0 text-left" onClick={() => onEdit(it)}>
              <div className="flex items-start justify-between gap-2">
                <div className="font-medium leading-snug break-words line-clamp-2">{first(it.data[titleF.key]) || "-"}</div>
                {hasK && <KondisiBadge kat={it.kondisi_kat} raw={it.data.kondisi} />}
              </div>
              {showPolda && <div className="mt-0.5 text-xs font-semibold text-primary">{it.polda}</div>}
              <dl className="mt-2 grid grid-cols-2 gap-x-3 gap-y-1.5 text-xs">
                {rest.slice(0, 4).map((f) => (
                  <div key={f.key} className="min-w-0">
                    <dt className="text-muted-foreground truncate">{f.label}</dt>
                    <dd className="truncate">{first(it.data[f.key]) || "-"}</dd>
                  </div>
                ))}
              </dl>
            </button>
          </div>
          <div className="mt-3 pl-9 flex gap-2">
            <Button size="sm" variant="outline" className="h-9 flex-1" onClick={() => onEdit(it)} data-testid={`card-edit-${it.item_id}`}>
              <Pencil className="h-4 w-4" /> Lihat / Ubah
            </Button>
            <Button size="sm" variant="outline" className="h-9 w-11 text-rose-600" onClick={() => onDelete(it)} data-testid={`card-delete-${it.item_id}`} aria-label="Hapus">
              <Trash2 className="h-4 w-4" />
            </Button>
          </div>
        </li>
      ))}
    </ul>
  );
};
